import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function ShowsNearbyNoLocation() {
  return (
    <div>
      <ExclamationCircleIcon className="inline-block" width={24} height={24} />{" "}
      We couldn&apos;t detect your location. Please enter your city to see shows
      nearby.
    </div>
  );
}
